module.exports = __webpack_public_path__ + "img/prize.e72ab29a.png";